var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "elevation-12",
      staticStyle: {
        position: "fixed",
        right: "0",
        "z-index": "15",
        "max-height": "calc(100% - 65px)",
        "overflow-y": "auto",
        "overflow-x": "hidden"
      }
    },
    [
      _c(
        "v-expansion-panels",
        {
          model: {
            value: _vm.panelExpanded,
            callback: function($$v) {
              _vm.panelExpanded = $$v
            },
            expression: "panelExpanded"
          }
        },
        [
          _c(
            "v-expansion-panel",
            { key: 0, attrs: { "expand-icon": "fa-arrow-alt-circle-down" } },
            [
              _c("v-expansion-panel-header", [
                _c("h2", { staticStyle: { "margin-right": "15px" } }, [
                  _c("span", { staticClass: "ml-2 hidden-xs-only" }, [
                    _vm._v("Powiązane (" + _vm._s(_vm.countAssigned) + ")")
                  ]),
                  _vm.panelExpanded != null
                    ? _c("span", { staticClass: "ml-2 hidden-sm-and-up" }, [
                        _vm._v(
                          "Powiązane zamówienia (" +
                            _vm._s(_vm.countAssigned) +
                            ")"
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _c(
                "v-expansion-panel-content",
                { staticStyle: { width: "430px" } },
                [
                  _c("div", [
                    _c("fieldset", { staticClass: "custom-fieldset" }, [
                      _c("legend", [_vm._v("To samo zamówienie")]),
                      _c(
                        "div",
                        {
                          staticClass: "pa-0 pb-3",
                          staticStyle: {
                            "overflow-y": "auto",
                            "max-height": "450px"
                          }
                        },
                        [
                          _vm.travelServiceOrderItems.length === 0
                            ? _c("div", [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("global.noData")) + " "
                                )
                              ])
                            : _vm._e(),
                          _vm._l(_vm.travelServiceOrderItems, function(
                            travelServiceOrderItem
                          ) {
                            return _c(
                              "div",
                              { key: travelServiceOrderItem.id },
                              [
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "mb-1",
                                    attrs: { "no-gutters": "" }
                                  },
                                  [
                                    _c("travel-service-order-item-chip", {
                                      attrs: {
                                        "travel-service-order-item": travelServiceOrderItem,
                                        "click-url":
                                          "/admin/travel-service/item/readonly/",
                                        "new-tab": true
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    ]),
                    _vm.relatedNotInTheSameOrder.length > 0
                      ? _c("fieldset", { staticClass: "custom-fieldset" }, [
                          _c("legend", [
                            _vm._v("Powiązane z innego zamówienia")
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "pa-0 pb-3",
                              staticStyle: {
                                "overflow-y": "auto",
                                "max-height": "450px"
                              }
                            },
                            [
                              _vm.travelServiceOrderItems.length === 0
                                ? _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("global.noData")) +
                                        " "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._l(_vm.relatedNotInTheSameOrder, function(
                                travelServiceOrderItem
                              ) {
                                return _c(
                                  "div",
                                  { key: travelServiceOrderItem.id },
                                  [
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c("travel-service-order-item-chip", {
                                          staticClass: "my-1",
                                          attrs: {
                                            "travel-service-order-item": travelServiceOrderItem,
                                            "click-url":
                                              "/admin/travel-service/item/readonly/",
                                            "new-tab": true
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              })
                            ],
                            2
                          )
                        ])
                      : _vm._e()
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }